import {AggregatedStoppageCodeStatistics, IssueGroupingKey} from '@domain/stoppages'
import {isEmpty} from 'lodash'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {isUnavailable} from '../utils'

import {useDepartmentNameMap} from './useDepartmentNameMap'

type UseEquipmentDetailsTitleParams = {
  groupType: IssueGroupingKey
  groupId: string
  stoppageStatsData?: AggregatedStoppageCodeStatistics
}

export const useEquipmentDetailsTitle = ({
  groupType,
  groupId,
  stoppageStatsData = {}
}: UseEquipmentDetailsTitleParams) => {
  const {t} = useTranslation()
  const isStoppedMainEquipment = groupType === IssueGroupingKey.STOPPED_MAIN_EQUIPMENT
  const departmentUpmIds = useMemo(
    () => (isStoppedMainEquipment && !isUnavailable(groupId) ? [groupId] : []),
    [isStoppedMainEquipment, groupId]
  )
  const departmentNameMap = useDepartmentNameMap({
    departmentUpmIds,
    isEnabled: isStoppedMainEquipment
  })
  if (isUnavailable(groupId)) return t('label.notAvailable')
  if (groupType === IssueGroupingKey.STOPPED_MAIN_EQUIPMENT) {
    return departmentNameMap.get(groupId) || groupId
  }
  if (isEmpty(stoppageStatsData)) return ''
  let title: string | undefined
  Object.keys(stoppageStatsData).forEach((stoppageCode) => {
    const stoppageCodeStats = stoppageStatsData[stoppageCode]

    if (groupType === IssueGroupingKey.EQUIPMENT_NUMBER) {
      title = stoppageCodeStats.equipments.find((equipment) => equipment.id === groupId)?.text
    }

    if (groupType === IssueGroupingKey.MAIN_EQUIPMENT) {
      title = stoppageCodeStats.mainEquipments.find(
        (mainEquipment) => mainEquipment.id === groupId
      )?.text
    }
  })
  return title || groupId
}
